import {Suggest} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {DISABLE_AUTOCOMPLETE} from '@yandex-delivery/nlf-form/v2'
import {useFormContext} from 'react-hook-form'

import type {LocationDetectedVariant} from '../../../api/address/model/types'
import {useFetchCityDesktop} from '../../../api/address/services/pickupPointService/pickupPoint'
import {useConfigContext} from '../../../contexts'
import {EventGoal, useFormUserEventHandler} from '../../../lib/metrika'
import type {ChangeHandler, Props} from './types'

export function CitySuggest({pointType, onChange, name}: Props): React.ReactElement {
  const i18n = useI18n()
  const {watch} = useFormContext()
  const {location} = useConfigContext()
  const fetchCity = useFetchCityDesktop()
  const handleReachGoal = useFormUserEventHandler()
  const isDisabledPointTypeDestination = pointType !== 'source' && watch('ndd.route.source.pickupPoint') === undefined
  const handleChange: ChangeHandler = (...props) => {
    onChange(...props)
    handleReachGoal(
      pointType === 'source'
        ? EventGoal.AddressCityFromSuggestResultItemClick
        : EventGoal.AddressCityToSuggestResultItemClick,
    )
  }

  return (
    <Suggest<LocationDetectedVariant>
      autoComplete={DISABLE_AUTOCOMPLETE}
      defaultText={watch(name)?.address}
      disabled={isDisabledPointTypeDestination}
      fetchSuggest={fetchCity}
      location={location}
      name={name}
      onChange={handleChange}
      onClick={() => {
        handleReachGoal(
          pointType === 'source' ? EventGoal.AddressCityFromSuggestClick : EventGoal.AddressCityToSuggestClick,
        )
      }}
      placeholder={i18n('ndd.point.point-selector.city_placeholder', 'Введите город или регион')}
      pointType={pointType}
      portal={false}
    />
  )
}
